"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PropTypes = require('prop-types');

var React = require('react');

var _ = require('lodash');

var template = require('./textEdit.jsx');

var displayNames = require('../displayNames');

var compose = require('../../hoc/compose');

var withClickOutside = require('../../hoc/withClickOutside');

var KEYS = require('../../constants/keyCodes');

var validate = function validate(validators, value) {
  var invalid = _.find(validators, function (_ref) {
    var validator = _ref.validator;
    return !validator(value);
  });

  return invalid && invalid.invalidMessage;
};

var TextEdit = /*#__PURE__*/function (_React$Component) {
  _inherits(TextEdit, _React$Component);

  var _super = _createSuper(TextEdit);

  function TextEdit(props) {
    var _this;

    _classCallCheck(this, TextEdit);

    _this = _super.call(this, props);
    _this.state = {
      value: props.value,
      invalidMessage: validate(props.validators, props.value)
    };

    _this.onInputTextChange = function (newVal) {
      _this.setState({
        value: newVal,
        invalidMessage: validate(props.validators, newVal)
      });
    };

    _this.isInvalid = function () {
      return !_.isUndefined(_this.state.invalidMessage);
    };

    _this.handleOnChange = function () {
      if (!_this.isInvalid()) {
        _this.applyChanges();
      }
    };

    _this.handleKeyDown = function (e) {
      if (_.includes([KEYS.ENTER, KEYS.ESC], e.keyCode)) {
        e.stopPropagation();
        e.preventDefault();

        if (e.keyCode === KEYS.ESC) {
          _this.props.cancel();
        } else {
          _this.handleOnChange();
        }
      }
    };

    _this.applyChanges = function () {
      return _this.props.onChange(_this.state.value);
    };

    return _this;
  }

  _createClass(TextEdit, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.props.onClickOutside(this.handleOnChange);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.keyboardShortcuts) {
        window.addEventListener('keydown', this.handleKeyDown, true);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.keyboardShortcuts) {
        window.removeEventListener('keydown', this.handleKeyDown, true);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return template.call(this);
    }
  }]);

  return TextEdit;
}(React.Component);

TextEdit.displayName = displayNames.SORT_BY_DRAG_LIST_TEXT_EDIT;
TextEdit.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  maxLength: PropTypes.number,
  validators: PropTypes.arrayOf(PropTypes.shape({
    validator: PropTypes.func.isRequired,
    invalidMessage: PropTypes.string.isRequired
  })),
  placeholder: PropTypes.string,
  shouldTranslateInvalidMessage: PropTypes.bool,
  autoFocus: PropTypes.bool,
  keyboardShortcuts: PropTypes.bool,
  buttonText: PropTypes.node
};
TextEdit.defaultProps = {
  autoFocus: false,
  shouldTranslateInvalidMessage: true,
  keyboardShortcuts: false
};
module.exports = compose(TextEdit, [withClickOutside]);